import { render, staticRenderFns } from "./role-component.vue?vue&type=template&id=df36e018&scoped=true&"
import script from "./role-component.vue?vue&type=script&lang=ts&"
export * from "./role-component.vue?vue&type=script&lang=ts&"
import style0 from "./role-component.vue?vue&type=style&index=0&id=df36e018&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df36e018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
